import { render, staticRenderFns } from "./more-history.vue?vue&type=template&id=7efee6d9&scoped=true&"
import script from "./more-history.vue?vue&type=script&lang=js&"
export * from "./more-history.vue?vue&type=script&lang=js&"
import style0 from "./more-history.vue?vue&type=style&index=0&id=7efee6d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efee6d9",
  null
  
)

export default component.exports